









import {Component, Provide, Vue} from 'vue-property-decorator';
import HomeFooter from '@/components/common/home/HomeFooter.vue';

@Component({ components: { HomeFooter } })
export default class Home extends Vue {

    @Provide()
    public date = new Date();

}
